import React, { useState, FormEvent, useEffect, useRef } from "react";
import { CardElement, useStripe, useElements, Elements } from "@stripe/react-stripe-js";
import { pricingdata } from "pages/Contracts/CreateProject/Tutorial/components/pricing";
import { getDecodeId } from "slices/userProfile/thunk";
import { getCards } from "slices/thunk";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Button } from "react-bootstrap";
import decodeJwt from "helpers/jwt-token-access/jwtdecode";
import { stripePromise, stripePromiseTest } from "slices/apiEndpoint";
import { CallAPIPostPromise } from "Common/commaon";
import { selectUserDetails, setSpinnerLoading } from "slices/userProfile/reducer";
import { getDecodedUserName } from "slices/subcontractors/thunk";
import api from "Common/api";
import "./stripe-subscription-modal.css";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  plan: any;
  afterSubmit: () => void;
  trialEligible?: boolean;
};

const SubscriptionModal: React.FC<Props> = ({
  isOpen,
  afterSubmit,
  onClose,
  plan,
  trialEligible = true,
}) => {
  const [selectedPlanDetails, setSelectedPlanDetails] = useState<any>("");
  const [primaryCard, setPrimaryCard] = useState<any>(null);
  const [useSavedCard, setUseSavedCard] = useState(true);

  const stripe = useStripe();
  const elements = useElements();
  const [videoPackage, setVideoPackage] = useState<
    "basic" | "pro" | "enterprise"
  >("basic");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const paymentAttemptKeyRef = useRef<string | null>(null);

  const userId = getDecodeId();
  const dispatch: any = useDispatch();
  const decodedToken = decodeJwt();
  const userEmail = decodedToken ? decodedToken.email : "";
 const userName =getDecodedUserName()
  useEffect(() => {
    if (isOpen) {
      setSelectedPlanDetails(plan);
      setMessage("")
    }
  }, [isOpen, plan]);
const user:any = useSelector(selectUserDetails)
const isEmployee = user[0]?.is_test_stripe_user ===1

  useEffect(() => {
    if (userId) {
      const loadCards = async () => {
        const cards = await dispatch(getCards(userId));
      if (cards && cards.length > 0) {
          const primary = cards.find((c: any) => c.isPrimary);
          if(primary){
            setPrimaryCard(primary);

          }else{
            setPrimaryCard(cards[0]); 
          }
        }else{
          setUseSavedCard(false)
        }
      };
      loadCards();
    }
  }, [userId, isOpen]);
  const handlePayNow = async () => {
    if (!stripe || !elements) return;
    if (paymentAttemptKeyRef.current) return;
    paymentAttemptKeyRef.current = `${Date.now()}_${Math.random().toString(36).slice(2)}`;
   dispatch(setSpinnerLoading("Please Wait..."))
    setLoading2(true);
    setMessage(null);
    try {
      let paymentMethodId: string;
      if (useSavedCard && primaryCard?.id) {
        paymentMethodId = primaryCard.id;
      } else {
        const cardElement = elements.getElement(CardElement);
        if (!cardElement) throw new Error("CardElement not found");

        const { paymentMethod, error } = await stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
        });

        if (error || !paymentMethod) {
          setMessage(error.message || "Failed to create payment method.");
          setLoading2(false);
   dispatch(setSpinnerLoading(false))

          return;
        }
        paymentMethodId = paymentMethod.id;
      }
    
      await CallAPIPostPromise(`/v2/api/subscription/pay-now`, {
        userId,
        paymentMethodId: paymentMethodId,
        amount: parseFloat(selectedPlanDetails.price.replace("$", "")),
        planType: selectedPlanDetails.plan_type,
        videoPackage,
        email: userEmail,
        first_priceID: isEmployee? selectedPlanDetails?.first_priceIDTest:selectedPlanDetails?.first_priceID
         ,
        regular_priceID:isEmployee?  selectedPlanDetails?.regular_priceIDTest: selectedPlanDetails?.regular_priceID 
         ,
        userName:userName,
        firstPayment: selectedPlanDetails?.firstPayment ? true : false,
        idempotencyKey: paymentAttemptKeyRef.current,
      })
        .then(() => {
          afterSubmit();
        })
        .catch((e: any) => {
          setMessage(e?.details || "Something went wrong");

          // setTimeout(() => {
          //   setMessage("");
          // }, 10000);
        }).finally(()=>{
          dispatch(setSpinnerLoading(false))
        })
    } catch (err: any) {
      console.log(err);
    } finally {
      setLoading2(false);
      paymentAttemptKeyRef.current = null;
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    dispatch(setSpinnerLoading('Please Wait...'))

    setLoading(true);
    setMessage(null);

    try {
      let paymentMethodId: string;
      if (useSavedCard && primaryCard?.id) {
        paymentMethodId = primaryCard.id;
      } else {
        const card = elements.getElement(CardElement);
        if (!card) throw new Error("CardElement not found");

        const { paymentMethod, error } = await stripe.createPaymentMethod({
          type: "card",
          card,
        });

        if (error || !paymentMethod) {
          setMessage(error?.message || "Payment method creation failed.");
          setLoading(false);
   dispatch(setSpinnerLoading(false))

          return;
        }

        paymentMethodId = paymentMethod.id;
      }

 await api.post(
        `/v2/api/subscription/create-subscription`,
        {
          userId,
          price: selectedPlanDetails.price.replace("$", ""),
          planType: selectedPlanDetails.plan_type,
          videoPackage: null,
          paymentMethodId,
          first_priceID: isEmployee? selectedPlanDetails?.first_priceIDTest:selectedPlanDetails?.first_priceID,
          regular_priceID: isEmployee?selectedPlanDetails?.regular_priceIDTest: selectedPlanDetails?.regular_priceID
           ,

          email: userEmail,
          interval: selectedPlanDetails.interval,
          firstPayment: selectedPlanDetails?.firstPayment
            ? parseFloat(selectedPlanDetails?.firstPayment.replace("$", ""))
            : "",
            userName:userName,
            userEmail:userEmail
        }
      );
      afterSubmit();
    } catch (err: any) {
      console.log(err);
      setMessage(err?.response?.data?.message ||err?.error|| "Something went wrong ");
    } finally {
      setLoading(false);
   dispatch(setSpinnerLoading(false))

    }
  };

  if (!isOpen) return null;

  return (
    <div className="tailwind-prefix stripe-subscription-modal">
      <div className="stripe-subscription-modal__backdrop fixed inset-0 flex items-center justify-center">
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="stripe-subscription-title"
          aria-describedby="stripe-subscription-description"
          className="stripe-subscription-modal__dialog w-full max-w-lg"
        >
          <div className="stripe-subscription-modal__header flex justify-between items-center">
            <div>
              <h2 id="stripe-subscription-title" className="stripe-subscription-modal__title">
                Subscribe to a Plan
              </h2>
              <p id="stripe-subscription-description" className="stripe-subscription-modal__subtitle">
                Choose a payment method and review your billing plan.
              </p>
            </div>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close subscription payment"
              className="stripe-subscription-modal__close"
            >
              <i className="bi bi-x-lg" aria-hidden="true" />
            </button>
          </div>

          <div className="stripe-subscription-modal__body">
            <div className="stripe-subscription-modal__field-group">
              <span className="stripe-subscription-modal__label">
                Payment Method
              </span>
              <div className="stripe-subscription-modal__payment-methods">
                {primaryCard && (
                  <button
                    type="button"
                    onClick={() => setUseSavedCard(true)}
                    aria-pressed={useSavedCard}
                    className={`stripe-subscription-modal__payment-method ${useSavedCard ? "is-selected" : ""}`}
                  >
                    <span className="stripe-subscription-modal__payment-method-title">Use Saved Card</span>
                    <span className="stripe-subscription-modal__payment-method-meta">
                      •••• •••• •••• {primaryCard.card?.last4}
                    </span>
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => setUseSavedCard(false)}
                  aria-pressed={!useSavedCard}
                  className={`stripe-subscription-modal__payment-method ${!useSavedCard ? "is-selected" : ""}`}
                >
                  <span className="stripe-subscription-modal__payment-method-title">Add New Card</span>
                  <span className="stripe-subscription-modal__payment-method-meta">Secure card entry</span>
                </button>
              </div>
            </div>

            <div className="stripe-subscription-modal__field-group">
              <label className="stripe-subscription-modal__label" htmlFor="stripe-subscription-plan">
                Plan Type
              </label>
              <select
                id="stripe-subscription-plan"
                value={selectedPlanDetails.plan}
                onChange={(e) =>
                  setSelectedPlanDetails(
                    pricingdata.find((b) => b.plan === e.target.value)
                  )
                }
                className="stripe-subscription-modal__select"
              >
                {pricingdata.map((m) => (
                  <option key={m.plan} value={m.plan}>
                    {m.plan}
                  </option>
                ))}
              </select>
            </div>

            {!useSavedCard && (
              <div className="stripe-subscription-modal__field-group">
                <label className="stripe-subscription-modal__label">
                  Card Details
                </label>
                <div className="stripe-subscription-modal__card-field">
                  <CardElement />
                </div>
                <span className="stripe-subscription-modal__field-help">Your card details are securely processed by Stripe.</span>
              </div>
            )}

            {message && (
              <Alert variant="danger" className="stripe-subscription-modal__alert">
                <strong>{message}</strong>
              </Alert>
            )}

            <div className="stripe-subscription-modal__summary" aria-label="Subscription summary">
              <div>
                <span>Selected plan</span>
                <strong>{selectedPlanDetails?.plan || "—"}</strong>
              </div>
              <div>
                <span>Billing amount</span>
                <strong>{selectedPlanDetails?.price || "—"}/{selectedPlanDetails?.interval || "—"}</strong>
              </div>
            </div>

            <div className="stripe-subscription-modal__actions">
              {trialEligible ? <button
                type="submit"
                onClick={handleSubmit}
                disabled={loading || loading2 || !stripe}
                aria-busy={loading}
                className="stripe-subscription-modal__action stripe-subscription-modal__action--primary"
              >
                {loading ? "Processing..." : "Subscribe with 30 days trial"}
              </button> : null}
              <Button
                disabled={loading || loading2 || !stripe}
                onClick={handlePayNow}
                aria-busy={loading2}
                className={`stripe-subscription-modal__action ${trialEligible ? "stripe-subscription-modal__action--secondary" : "stripe-subscription-modal__action--primary"}`}
              >
                {loading2 ? "Processing..." : "Pay Now & Start Subscription"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SubscriptionModalDefult: React.FC<Props> = ({
  isOpen,
  afterSubmit,
  onClose,
  plan,
  trialEligible = true,
}) => {
 
  const user:any = useSelector(selectUserDetails)
  const isEmployee = user[0]?.is_test_stripe_user ===1
  if (!isOpen) return null;

  return (
    <Elements stripe={ isEmployee?stripePromiseTest: stripePromise}>
       
       <SubscriptionModal plan={plan} isOpen={isOpen} afterSubmit={afterSubmit} onClose={onClose} trialEligible={trialEligible} />
   
    </Elements>
  );
};
export default SubscriptionModalDefult;
